const URL = {
    PRACUJ: {
        ADVICES: 'https://porady.pracuj.pl/?utm_source=erecruiter&utm_medium=konto&utm_campaign=konto_er_test_content',
        CREATOR: 'https://cv.pracuj.pl/?utm_source=erecruiter&utm_medium=konto&utm_campaign=konto_er_test_kreator',
        EARNINGS: 'https://zarobki.pracuj.pl/?utm_source=erecruiter&utm_medium=konto&utm_campaign=konto_er_test_salary',
        ARCHIVED: 'https://www.pracuj.pl/praca?utm_source=erecruiter&utm_medium=konto&utm_campaign=empty_list_er',
        MAIN: 'https://pracuj.pl/?utm_source=erecruiter&utm_medium=konto&utm_campaign=konto_er_test_main'
    },
    THEPROTOCOL: 'https://theprotocol.it/?utm_source=erecruiter&utm_medium=konto&utm_campaign=protocol&utm_term=konto_user_eryk'
};
export default URL;